var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.ClusterSource = new Class({
    Extends: OCS.Viewer.Classes.VectorSource,
    class_name: "VectorSource",
    vector_source: null,
    options: {
        init: {
            cluster_distance: 2
        },
        metadata: {
            source_type: 'Cluster'
        }
    },
    initialize: function (ops) {
        this.setOptions(ops);
        this.get_vector_source();
    },
    create: function () {
        if (!this.get_ol_object()) {
            var options = this.options;
            var source_ops = this.get_source_ops(options);
            this.set_ol_object(new ol.source.Cluster(source_ops));
        }
        return this.get_ol_object();
    },
    get_source_ops: function (options) {
        var ops = {
            projection: this.options.projection,
            distance: this.options.init.cluster_distance,
            source: this.vector_source.get_source()
        };
        return ops;
    },
    get_vector_source: function () {
        if (!this.vector_source) {
            var vec_ops = OCS.Viewer.Functions.get_utilities().clone_object(this.options);
            vec_ops.metadata.source_type = "Vector";
            this.vector_source = new OCS.Viewer.Classes.VectorSource(vec_ops);
            this.vector_source.addEvent('ready', this.data_source_ready.bind(this));
            this.addEvent('refresh', this.vector_source.refresh_source.bind(this.vector_source));
            this.addEvent('changed', this.vector_source.source_changed.bind(this.vector_source));
        }
        return this.vector_source;
    },
    set_vector_source: function (vs) {
        this.vector_source = vs;
    },
    data_source_ready: function () {
        if (!this.ready) {
            this.ready = true;
            // Now that we have the vector source ready, we can create the source
            this.create();
            this.fireEvent('refresh', this, 1);
            this.fireEvent('ready', this, 2);
        }
    },
    set_data: function (data) {
        if (data) {
            var vs = this.get_vector_source();
            vs.set_data(data);
        }
    },
    add_feature: function (feature) {
        var vs_source = this.get_vector_source();
        vs_source.add_feature(feature);
        this.fireEvent('changed', this, 1);
    },
    add_features: function (features) {
        var vs_source = this.get_vector_source();
        vs_source.add_features(features);
        this.fireEvent('changed', this, 1);
    },
    get_features: function () {
        var source = this.get_vector_source();
        return source.get_features();
    },
    remove_feature: function (feature) {
        var vs_source = this.get_vector_source();
        vs_source.remove_feature(feature);
        this.get_source().changed();
        this.fireEvent('changed', this, 1);
    },
    clear: function () {
        var vs_source = this.get_vector_source();
        vs_source.clear();
        this.parent();
        this.fireEvent('changed', this, 1);
    },
    destroy: function () {
        if (this.vector_source) {
            this.vector_source.destroy();
            this.vector_source = null;
        }
        this.parent();
    }
});
